const EXITED = 'exited';

export { EXITED as E };
//# sourceMappingURL=Transition-QJ5gMye0.js.map
